import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	reportsBreadcrumbTitle: {
		id: 'software-reports-report-page.reports-breadcrumb-title',
		defaultMessage: 'Reports',
		description: 'The display text used in the breadcrumbs that can navigate to reports page.',
	},
});
